import React from 'react';

import { CookiebotVideoGate, useFallbackTranslation } from '@gn-audio/jss-components';

interface VideoEmbedProps {
  youtubeId: string;
  youkuId: string;
  className?: string;
}

const VideoEmbed: React.FC<VideoEmbedProps> = ({ youtubeId, youkuId, className }) => {
  const { t } = useFallbackTranslation();

  if (!youtubeId && !youkuId) return null;

  return (
    <CookiebotVideoGate youtubeId={youtubeId} isYouku={!!youkuId} className={className}>
      <iframe
        className={className}
        // tabIndex={tabIndex}
        src={
          youkuId
            ? `https://player.youku.com/embed/${youkuId}`
            : `https://www.youtube.com/embed/${youtubeId}`
        }
        title={youkuId ? t('system.YouKuPlayer') : t('system.YouTubePlayer')}
        allow={
          youkuId
            ? undefined
            : 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        }
        allowFullScreen
      />
    </CookiebotVideoGate>
  );
};

export default VideoEmbed;
